import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';
import { inviteApplicant, bypassApplicant, submitRenewal } from '../../store/actions';
import { getRentRollStats, getRentRoll } from 'actions/landlordTenantsActions';
import Loading from '../Loading';
import Error from '../Error';
import Success from '../Success';

const PAGE_STATES = {
  loading: 'loading',
  error: 'error',
  loaded: 'loaded',
  no_renewals: 'no_renewals',
};

const SubmitRenewal = ({
  closeWizard,
  pageIndex,
  setPageIndex,
  hideWizardControls,
  inviteApplicant,
  bypassApplicant,
  selectedApplicants,
  cotenants,
  renewal,
  submitRenewal,
  getRentRollStats,
  getRentRoll,
}) => {
  const [pageState, setPageState] = useState(PAGE_STATES.loading);

  useEffect(() => {
    hideWizardControls();
    handleRenewalCreation();
    // eslint-disable-next-line
  }, []);

  const handleRenewalCreation = async () => {
    try {
      if (pageState !== PAGE_STATES.loading) {
        setPageState(PAGE_STATES.loading);
      }

      if (selectedApplicants.length > 0) {
        const applicantIds = selectedApplicants.map(applicant => applicant.id);
        const leaseHolders = cotenants.filter(cotenant => !applicantIds.includes(cotenant.id));

        for (const id of applicantIds) {
          await inviteApplicant(id);
        }
        for (const leaseHolder of leaseHolders) {
          await bypassApplicant(leaseHolder.id);
        }
      } else {
        for (const cotenant of cotenants) {
          await bypassApplicant(cotenant.id);
        }
        await submitRenewal(renewal.id);
      }

      setPageState(PAGE_STATES.loaded);
    } catch (err) {
      setPageState(PAGE_STATES.error);
    }
  };

  const handleBack = () => {
    setPageIndex(pageIndex - 1);
  };

  const reloadRentRollAndCloseWizard = () => {
    getRentRollStats();
    getRentRoll();
    closeWizard();
  };

  if (pageState === PAGE_STATES.loading) {
    return (
      <Loading
        bodyText={getTranslatedString('landlordPortal.rentRoll.renewals.pleaseDontReload')}
      />
    );
  } else if (pageState === PAGE_STATES.error) {
    return (
      <Error
        onClick={handleBack}
        headerText={getTranslatedString('landlordPortal.rentRoll.renewals.oops')}
        bodyText={getTranslatedString('landlordPortal.rentRoll.renewals.weWereUnableToProcess')}
        buttonText={getTranslatedString('landlordPortal.rentRoll.renewals.back')}
      />
    );
  } else if (pageState === PAGE_STATES.loaded) {
    return <Success onClick={reloadRentRollAndCloseWizard} />;
  }
};

const mapStateToProps = store => ({
  cotenants: store.landlord.renewals.leaseCotenants,
  leaseId: store.landlord.renewals.leaseId,
  selectedProposal: store.landlord.renewals.selectedProposal,
  selectedLeaseTerm: store.landlord.renewals.selectedLeaseTerm,
  details: store.landlord.renewals.details,
  selectedApplicants: store.landlord.renewals.selectedApplicants,
  renewal: store.landlord.renewals.renewal,
});

const mapDispatchToProps = {
  inviteApplicant,
  bypassApplicant,
  submitRenewal,
  getRentRollStats,
  getRentRoll,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitRenewal);
